/*
 *   Copyright (c) 2021 vlinder Labs Private Limited
 *   All rights reserved.
 *   This software is proprietary of Vlinder Labs Pvt. Ltd and can not be distributed / used for any purpose outside of Vlinder Labs Pvt. Ltd without explicit written consent from the copyright owner.
 */
//@ts-nocheck
import React from 'react';
import * as S from './styles';

export interface IHeroContentProps {
  title?: string;
  subtitle?: string;
  auth?: string;
}

export const HeroContent = (props: IHeroContentProps) => {
  const { title, subtitle, auth } = props;
  return (
    <div style={{ paddingLeft: '2%', paddingTop: '2%' }}>
      <S.Title>
        {title} {auth && <S.IconImage src={auth} />}
      </S.Title>
      <S.SubTitle>{subtitle}</S.SubTitle>
    </div>
  );
};

HeroContent.defaultProps = {
  title: '',
  subtitle: '',
};
